import { normalizeQuantity } from './quantity';

export const SCALE_READING_LINE_SOURCE = 'scale';

export const getCartIdentityKey = (entry) => {
  if (entry?.cartLineId) return `line:${entry.cartLineId}`;
  const priceIndex = Number.isInteger(entry?.sourcePriceIndex)
    ? entry.sourcePriceIndex
    : entry?.priceIndex;
  return `${entry?.varietyId}:${priceIndex}`;
};

export const isScaleReadingLine = (entry) =>
  Boolean(entry?.isScaleReadingLine || entry?.source === SCALE_READING_LINE_SOURCE);

export const createScaleReadingLine = ({
  varietyId,
  varietyPriceId,
  priceIndex,
  quantity,
}) => ({
  cartLineId: `scale-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  isScaleReadingLine: true,
  source: SCALE_READING_LINE_SOURCE,
  varietyId,
  varietyPriceId,
  priceIndex,
  quantity: normalizeQuantity(quantity, 3),
  createdAt: new Date().toISOString(),
});

export const buildScaleReadingOrderEntry = (line) => ({
  cartLineId: line.cartLineId,
  isScaleReadingLine: true,
  source: SCALE_READING_LINE_SOURCE,
  varietyId: line.varietyId,
  varietyPriceId: line.varietyPriceId ?? null,
  priceIndex: line.priceIndex,
});

export const findDuplicateScaleReadingLine = (lines, varietyId, quantity) => {
  const normalizedQuantity = normalizeQuantity(quantity, 3);
  return (Array.isArray(lines) ? lines : []).find((line) =>
    isScaleReadingLine(line)
    && Number(line?.varietyId) === Number(varietyId)
    && normalizeQuantity(line?.quantity, 3) === normalizedQuantity
  ) || null;
};

export const lineMatchesPrice = (line, varietyId, priceIndex, price) => {
  if (!line || Number(line.varietyId) !== Number(varietyId)) return false;
  const linePriceIndex = Number.isInteger(line.sourcePriceIndex)
    ? line.sourcePriceIndex
    : line.priceIndex;
  if (Number.isInteger(linePriceIndex) && Number(linePriceIndex) === Number(priceIndex)) {
    return true;
  }
  return line.varietyPriceId != null && Number(line.varietyPriceId) === Number(price?.id);
};
